<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/print/template/rule/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('dayinmobanmingcheng')">
            <el-input v-model="yt.conditions.printTemplateName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dayinmobanleixing')">
            <yi_dictionary_select :max="999" type="PRINT_TEMPLATE_TYPE" :ids.sync="yt.conditions.printTemplateType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select multiple type="material2" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('kehubianma')">
            <el-input v-model="yt.conditions.otherCustomerCode"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_base_label_management_print_template_rule_create')" size="mini" type="primary" @click="yt.showEditDialog('xinzeng', null, 'w1', beforeShowEditDialogInsert)">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_base_label_management_print_template_rule_import')" size="mini" plain @click="importShow = !importShow">
          {{ $t('daoru') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, null, beforeShowEditDialogEdit)" v-if="utils.checkPower('web_base_label_management_print_template_rule_update')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" :loading="yt.editObj.loading" @click="yt.remove(scope.row, '/web/print/template/rule/delete')" v-if="utils.checkPower('web_base_label_management_print_template_rule_delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('dayinmobanleixing')" required>
            <yi_dictionary_select :max="999" type="PRINT_TEMPLATE_TYPE" :ids.sync="yt.editObj.printTemplateType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('dayinyewuleixing')" required>
            <yi_dictionary_select :max="999" type="PRINT_TEMPLATE_BUSINESS_TYPE" :ids.sync="yt.editObj.printBusinessType" @change="typeChange(yt.editObj.printBusinessType)"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('dayinmobanmingcheng')" required>
            <el-select v-model="yt.editObj.printTemplateId" :placeholder="$t('qingxuanze')" filterable :loading="printTemplateLoading">
              <el-option v-for="item in printTemplates" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <div v-show="yt.editObj.printTemplateType === '2'">
            <el-form-item :label="$t('chanpinbianma/mingcheng')">
              <yi_data_select type="material2" :ids.sync="yt.editObj.materialId"> </yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('kehubianma')" required>
              <el-input v-model="yt.editObj.otherCustomerCode"></el-input>
            </el-form-item>
            <el-form-item :label="$t('dayinbiaoshifu')">
              <el-input v-model="yt.editObj.printFlagStr"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/print/template/rule/create')" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('dayinmobanleixing')" required>
            <yi_dictionary_select :max="999" disabled type="PRINT_TEMPLATE_TYPE" :ids.sync="yt.editObj.printTemplateType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('dayinyewuleixing')" required>
            <yi_dictionary_select :max="999" type="PRINT_TEMPLATE_BUSINESS_TYPE" :ids.sync="yt.editObj.printBusinessType" @change="typeChange(yt.editObj.printBusinessType)"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('dayinmobanmingcheng')" required>
            <el-select v-model="yt.editObj.printTemplateId" :placeholder="$t('qingxuanze')" filterable :loading="printTemplateLoading">
              <el-option v-for="item in printTemplates" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <div v-show="yt.editObj.printTemplateType === '2'">
            <el-form-item :label="$t('chanpinbianma/mingcheng')">
              <yi_data_select type="material2" :ids.sync="yt.editObj.materialId"> </yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('kehubianma')" required>
              <el-input v-model="yt.editObj.otherCustomerCode"></el-input>
            </el-form-item>
            <el-form-item :label="$t('dayinbiaoshifu')">
              <el-input v-model="yt.editObj.printFlagStr"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/print/template/rule/update')" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 导入 -->
    <import_template_rule :show.sync="importShow" />
  </div>
</template>
<script type="text/javascript">
import import_template_rule from './import_template_rule.vue';

export default {
  name: 'web_label_management_print_template_rule_list',
  components: {
    import_template_rule
  },
  data() {
    return {
      printTemplateLoading: false,
      printTemplates: [],
      importShow: false,
      columns: [
        {
          label: 'dayinmobanmingcheng',
          prop: 'printTemplateInfo.name'
        },
        {
          label: 'dayinmobanleixing',
          prop: 'printTemplateType',
          type: 'dictionary_tag',
          key: 'PRINT_TEMPLATE_TYPE'
        },
        {
          label: 'dayinyewuleixing',
          prop: 'printTemplateInfo.type',
          type: 'dictionary_tag',
          key: 'PRINT_TEMPLATE_BUSINESS_TYPE'
        },
        {
          label: 'chanpinbianma',
          prop: 'materialInfo.code'
        },
        {
          label: 'chanpinmingcheng',
          prop: 'materialInfo.name'
        },
        {
          label: 'kehubianma',
          prop: 'otherCustomerCode'
        },
        {
          label: 'dayinbiaoshifu',
          prop: 'printFlagStr'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'chuangjianren',
          prop: 'createByInfo.nickname'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  destroyed() {
    this.utils.event_hub.$off('PRINT_TEMPLATE_RULE_REFRESH');
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);

      this.utils.event_hub.$on('PRINT_TEMPLATE_RULE_REFRESH', () => {
        this.yt.get();
      });
    }, 300);
  },
  methods: {
    // 新增之前处理数据
    beforeShowEditDialogInsert(row) {
      row.printTemplateType = "1";
      row.printBusinessType = "0";
      this.typeChange("0");
      return row;
    },

    // 编辑之前处理数据
    beforeShowEditDialogEdit(row) {
      row.printBusinessType = row.printTemplateInfo.type;
      this.typeChange(row.printTemplateInfo.type);
      return row;
    },
    // 新增/编辑弹窗中选择打印类型时调用
    typeChange(type) {
      // 加载打印模板信息
      this.printTemplateLoading = true;
      this.http
        .get('/web/print/template/list/by/type?type=' + type)
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.printTemplates = res.data;
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.printTemplateLoading = false;
        });
    }
  }
};
</script>
